import axios from "axios";

export const IsRechargeProduct = async (productId) => {
    try {
        const response = await axios.get(`/api/JoyTel/is-recharge-product`, {
            params: { productId },
        });

        if (response && response.status === 200) {
            return response.data;
        }
        return { status: false, message: "Failed to check product type" };
    } catch (error) {
        console.error("IsRechargeProduct Error:", error);
        return { status: false, message: error.message };
    }
};

export const ProcessRecharge = async (productId, snCode, days = 1) => {
    try {
        const response = await axios.post(`/api/JoyTel/process-recharge`, {
            productId,
            snCode,
            days
        });

        if (response && response.status === 200) {
            return response.data;
        }
        return { status: false, message: "Recharge failed" };
    } catch (error) {
        console.error("ProcessRecharge Error:", error);
        return { status: false, message: error.message };
    }
};

export const getAllRechargeHistoryList = async (
    email = null,
    snCode = null,
    startDate = null,
    endDate = null
) => {
    try {
        const params = {};
        if (email) params.email = email;
        if (snCode) params.snCode = snCode;
        if (startDate) params.startDate = startDate;
        if (endDate) params.endDate = endDate;

        const response = await axios.get(
            `/api/OrderHistory/GetAllRechargeHistoryList`,
            { params }
        );

        if (response && response.status === 200) {
            return response.data;
        }
        return [];
    } catch (error) {
        console.error("GetAllRechargeHistoryList Error:", error);
        if (error.response && error.response.status === 401) return 401;
        return [];
    }
};

export const getRspOrderIdBySnCode = async (snCode) => {
    try {
        const response = await axios.post(`/api/JoyTel/rsp-order-by-sncode`, {
            snCode,
        });

        if (response && response.status === 200) {
            return response.data;
        }
        return { status: false, message: "Failed to look up RSP order ID" };
    } catch (error) {
        console.error("getRspOrderIdBySnCode Error:", error);
        return { status: false, message: error.message };
    }
};

export const QueryRechargeStatus = async (rechargeCode) => {
    try {
        const response = await axios.post(`/api/JoyTel/query-recharge`, {
            rechargeCode,
        });

        if (response && response.status === 200) {
            return response.data;
        }
        return { status: false, message: "Failed to query recharge status" };
    } catch (error) {
        console.error("QueryRechargeStatus Error:", error);
        return { status: false, message: error.message };
    }
};

export const QueryCardStatus = async (cid) => {
    try {
        const response = await axios.post(`/api/JoyTel/query-card-status`, {
            cid,
        });

        if (response && response.status === 200) {
            return response.data;
        }
        return { status: false, message: "Failed to query card status" };
    } catch (error) {
        console.error("QueryCardStatus Error:", error);
        return { status: false, message: error.message };
    }
};

export const QueryCardUsage = async (cid, orderId) => {
    try {
        const response = await axios.post(`/api/JoyTel/query-card-usage`, {
            cid,
            orderId,
        });

        if (response && response.status === 200) {
            return response.data;
        }
        return { status: false, message: "Failed to query card usage" };
    } catch (error) {
        console.error("QueryCardUsage Error:", error);
        return { status: false, message: error.message };
    }
};

export const getRechargeHistoryList = async (
    email,
    startDate = null,
    endDate = null
) => {
    try {
        const params = { email };
        if (startDate) params.startDate = startDate;
        if (endDate) params.endDate = endDate;
        const response = await axios.get(
            `/api/OrderHistory/GetRechargeHistoryList`, { params }
        );

        if (response && response.status === 200) {
            return response.data;
        }
        return { status: false, message: "Failed to fetch recharge history" };
    } catch (error) {
        console.error("GetRechargeHistoryList Error:", error);

        if (error.response) {
            if (error.response.status === 401) {
                return { status: false, message: "Unauthorized", statusCode: 401 };
            }
            if (error.response.data && error.response.data.message) {
                return { status: false, message: error.response.data.message };
            }
        }

        return { status: false, message: error.message || "An error occurred" };
    }
};
